import React from 'react'
import { MessageMetaPayload, MessageMetaContent } from 'api/support'
import LesaHotelOfferCard from './LesaHotelOfferCard'
import LesaBedbankOfferCard from './LesaBedbankOfferCard'
import { isBedbank, isLEHotel } from 'lib/offer/offerTypes'

interface Props {
  offer: App.AnyOffer;
  hideSelect?: boolean;
  actions?: MessageMetaContent[];
  payload?: MessageMetaPayload;
  handleAction: (message: string, meta: any) => void;
}

function LesaOfferSummary({ hideSelect, offer, actions, handleAction, payload }: Props) {
  if (isLEHotel(offer)) {
    return <LesaHotelOfferCard actions={actions} offer={offer} handleAction={handleAction} hideSelect={hideSelect} payload={payload} />
  }

  if (isBedbank(offer)) {
    return <LesaBedbankOfferCard actions={actions} offer={offer} handleAction={handleAction} hideSelect={hideSelect} payload={payload} />
  }

  return null
}

export default LesaOfferSummary
